/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// import moment from 'moment';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loading from '../../components/Loading';

import * as libraryService from '../../services/libraries';

import stylesLayout from '../../common/layout.module.scss';
import LibrariesTable from '../../components/LibrariesTable';

const LibrariesModule = (
) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [libraries, setLibraries] = useState([]);

  const loadLibraries = async () => {
    setLoading(true);
    const rsp = await libraryService.all();
    if (rsp && rsp.status) {
      setLibraries(rsp.data);
    }
    setLoading(false);
  };

  const onAction = (action, hash) => {
    switch (action) {
      case 'view':
        history.push(`/biblioteca/${hash}`);
        break;
      default:
    }
  };

  useEffect(() => {
    loadLibraries();
  }, []);

  if (loading) {
    return <div className={stylesLayout.page}><Loading /></div>;
  }

  // const stepsStore = getStepsStore(store);
  // const pendingStepsStore = (stepsStore.filter((x) => !x.completed));
  return (
    <div className={stylesLayout.page}>
      <div className={stylesLayout.title}>
        Bibliotecas
        <div className={stylesLayout.secAction}>
          <Button onClick={() => { history.push('/biblioteca/nueva'); }}>
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />
            Agregar
          </Button>
        </div>
      </div>
      <div className={stylesLayout.content}>
        <LibrariesTable
          items={libraries}
          onAction={onAction}
        />
      </div>
    </div>
  );
};

LibrariesModule.propTypes = {
};

export default LibrariesModule;
